import { Link } from '@reach/router';
import { HasPermission } from 'app/components/shared/HasPermission';
import React from 'react';
import { ArcadeListItem } from 'routes/arcades/interfaces';
import { ARCADE_PATH_CREATE } from 'routes/paths';
import SharedList from '../../../shared/list';

interface Props {
    getArcades: () => void;
    list: ArcadeListItem[];
}

const ArcadeList = (props: Props) => {
    return (
        <>
            <SharedList
                notFoundMessage={
                    <>
                        <p>No Arcades found for this company</p>
                        <br />
                        <HasPermission app="arcade-api" permission="create-arcade">
                            {(hasPermission: boolean) => hasPermission &&
                                <Link
                                    className='button intent-primary'
                                    to={'.' + ARCADE_PATH_CREATE}
                                    id="add-new-arcade-button"
                                >
                                    Add New Arcade
                                </Link>
                            }
                        </HasPermission>
                    </>
                }
                getList={props.getArcades}
                list={props.list}
            />
        </>
    );
};

export default ArcadeList;
